/**
 * Transfer service
 */
import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { flow } from 'lodash';

import { BaseService } from '../base';
import { IBaseEntityType, IEntityConfig, ITransfer } from '@shared/types';
import { lazyInject } from '@app/containers/base/decorators';
import { PermissionService } from '../session/permission.service';
import { config } from './transfer-destinations.service.config';
import { Subscription } from 'rxjs';

/**
 * Transfer service that extends BaseService to use
 * basic CRUD request operations
 */
@Injectable()
export class TransferDestinationsService extends BaseService {
  public static config: IEntityConfig = config;
  public static ENTITY_TYPE: string = config.ENTITY_TYPE;

  @lazyInject(PermissionService) public permissionService: PermissionService;

  public subscriptions: Subscription[] = [];
  public quickFilterFields: string[] = ['name'];
  public listProjection: string[] = ['name'];
  public headerNames: ColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      filter: false,
    },
  ];

  public frontToBackItemMapper(doc: ITransfer): IBaseEntityType {
    return flow(super.frontToBackItemMapper.bind(this))(doc);
  }
}
